(function($) {
  'use strict';

  const threeup = {
    dom: function() {
      this.$imageContainer = $('.js-threeup-image');
    },

    imageMovement: function() {
      this.$imageContainer.each(function() {
        const $this = $(this);
        const $pictureElement = $this.find('.js-threeup-picture');
        let offset = 0;
        $pictureElement.each(function() {
          const $picture = $(this);
          gsap.fromTo($picture, {
            y: '50%'
          },{
            scrollTrigger: {
              trigger: $this,
              start: 'top bottom-=' + (offset / 2) + '%',
              end: 'bottom bottom-=' + offset + '%',
              toggleActions: 'restart none reverse reset',
              scrub: true
            },
            y: '0'
          });
          offset = offset + 20;
        })
      });
    },

    ready: function() {
      this.dom();
      this.imageMovement();
    }
  };

  $(function() { threeup.ready(); });

})(jQuery);
